import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { readPref, writePref } from "../utils/prefs";

const PREF_KEY = "idb_theme";
const LEGACY_LS_KEY = "alterego_theme";

const ThemeContext = createContext();

function readInitialTheme() {
  const fromCookie = readPref(PREF_KEY, "");
  if (fromCookie === "dark" || fromCookie === "light") return fromCookie;
  // One-time migration from legacy localStorage value (if present)
  try {
    const legacy = localStorage.getItem(LEGACY_LS_KEY);
    if (legacy === "dark" || legacy === "light") {
      writePref(PREF_KEY, legacy);
      try {
        localStorage.removeItem(LEGACY_LS_KEY);
      } catch (err) {
        console.warn("[ThemeContext] removeItem legacy key failed:", err);
      }
      return legacy;
    }
  } catch (err) {
    console.warn("[ThemeContext] legacy localStorage read failed:", err);
  }
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    writePref(PREF_KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => setTheme(t => (t === "dark" ? "light" : "dark")), []);

  const value = useMemo(() => ({ theme, toggle }), [theme, toggle]);
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
